import { render, staticRenderFns } from "./PollDraftHandler.vue?vue&type=template&id=89fca236&scoped=true"
import script from "./PollDraftHandler.vue?vue&type=script&setup=true&lang=ts"
export * from "./PollDraftHandler.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PollDraftHandler.vue?vue&type=style&index=0&id=89fca236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fca236",
  null
  
)

export default component.exports